import { camelCase, camelCaseTransformMerge } from 'camel-case';

export const toCamelCase = (value: string): string => {
  return camelCase(value, { transform: camelCaseTransformMerge });
};
